import { combineReducers } from "redux";
import resourcesReducer from "./resources/resourcesSlice";
import fileDisplayReducer from "./fileDisplay/fileDisplaySlice";
import fileThumbnailsReducer from "./fileThumbnails/fileThumbnailsSlice";
import errorsReducer from "./errors/errorsSlice";
import resourceSearchReducer from "./resourceSearch/resourceSearchSlice";
import requestingReducer from "./requesting/requestingReducer";

const rootReducer = combineReducers({
  resources: resourcesReducer,
  fileDisplayUrl: fileDisplayReducer,
  fileThumbnails: fileThumbnailsReducer,
  resourceSearch: resourceSearchReducer,
  errors: errorsReducer,
  requesting: requestingReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
